module.exports = __webpack_public_path__ + "2ba116e6563909e27a66376a6dbc1c98.woff2";